<!--
  @Description: 
  @Author: wang.y 
  @Date: 2022-05-31 
-->
<template>
  <div class="login">
    <div class="login-container">
      <div class="header">
        <img :src="$store.state.static_img_url+'pic/logo.png'">
      </div>
      <div class="content">
        <p class="tip">手机验证码登录</p>
        <Form ref="code_logoin_form" :model="code_logoin_form" :rules="ruleValidate">
          <FormItem prop="mobile">
            <Input v-model="code_logoin_form.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
          </FormItem>
          <FormItem v-if="nc_status">
            <div class="nc-cnt">
              <div id="nc"></div>
            </div>
          </FormItem>
          <FormItem prop="code">
            <Input v-model="code_logoin_form.code" placeholder="请输入验证码" autocomplete="off"></Input>
            <Captcha
              ref="captcha"
              scene="vbdata_loginon"
              :mobile="code_logoin_form.mobile"
            ></Captcha>
          </FormItem>
        </Form>
        <Button @click="loginOnPhone" :loading="login_button_loading">登录</Button>
      </div>
    </div>
  </div>
</template>
<script>
import { loginOnPhone, liveurl } from '@/service'
import Captcha from '@/components/Captcha'
export default {
  components: {
    Captcha
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  data() {
    return {
      form_type: 'code_logoin_form',
      ruleValidate: {
        mobile: [
          { required: true, message: '请输入您的联系电话', trigger: 'blur' },
          {
            type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            },
          },
        ],
        code: [{ required: true, message: '请填写正确的验证码', trigger: 'blur' }],
        pic_code: [{ required: true, message: '请填写正确的图片验证码', trigger: 'blur' }],
      },
      code_logoin_form: {
        mobile: '',
        code: '',
        pic_code: '',
        login_type: '1',
        scene: 'vbdata_loginon',
      },
      login_button_loading: false,
    }
  },
  computed: {},
  methods: {
    loginOnPhone() {
      // 验证码登录和账号密码
      this.$refs[this.form_type].validate(async (valid) => {
        if (valid) {
          this.login_button_loading = true
          let res = await loginOnPhone(this[this.form_type], (error) => {
            this.$Message.error('请求失败！')
          })
          this.login_button_loading = false
          if (res.status == 'success') {
            this.logoSuccess(res)
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
    async getliveurl(id, url, user_key) {
      let res = await liveurl(
        {
          loginType: 2,
          aliveId: id,
          redirectUrl: url,
          userKey: user_key,
        },
        (error) => {
          this.$message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        let tourl = res.data.loginUrl
        window.location.href = tourl
      } else {
        this.$message.error(res.msg)
      }
    },
    logoSuccess(res) {
      localStorage.user_key = res.user_key
      localStorage.user = JSON.stringify(res.user)
      localStorage.timestamp_left = moment().unix()
      localStorage.timestamp_right = moment().unix()

      this.$store.commit('updateUserKey', res.user_key)
      this.$store.commit('updateUser', res.user)
      this.$store.commit('setUUserId', res.user.id)
      
      if (this.$route.query.redirect_uri) {
        this.getliveurl('', this.$route.query.redirect_uri, res.user_key)
        return false
      }
      if (this.$route.query.formRouter == 'MLive' && this.$route.query.aliveId) {
        this.getliveurl(this.$route.query.aliveId, '', res.user_key)
        return false
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.login
  height 100vh
  .login-container
    width 100%
    padding 0
    .header
      padding .32rem .4rem
      border-bottom .02rem solid #f5f5f5
      img
        height .64rem
        display block
    .content
      padding .48rem .56rem .56rem
    .tip
      font-size .32rem
      color #333333
      line-height 1
    >>> .ivu-form
      margin-top .32rem
      .ivu-form-item
        margin-bottom .4rem
        .ivu-form-item-content
          .ivu-input
            background #F8F8FA
            border-color #F8F8FA
            border-radius .08rem
            color #333
            height .8rem
            font-size .28rem
            padding .2rem
            &::-webkit-input-placeholder
              color #999
            &:focus
              box-shadow none
              border-color rgba(250, 122, 80, 1)
          .code-btn
            position absolute
            z-index 2
            top .2rem
            right .2rem
          .forget-paw
            position absolute
            top .8rem
            right 0
            font-size .28rem
            color #999999
            cursor pointer
            &:hover
              color #FC9C7C
        &:last-of-type
          margin-bottom 0
        .ivu-form-item-error-tip
          position inherit
          color #F3494B
        &.ivu-form-item-error
          .ivu-input
            border-color #F3494B
    .ivu-btn
      width 100%
      height .8rem
      background rgba(250, 122, 80, 1)
      border-radius .08rem
      border-color rgba(250, 122, 80, 1)
      font-size .28rem
      color #FFFFFF
      margin-top .6rem
      &:focus
        box-shadow none
      &:hover
        background-color #FC9C7C
        border-color #FC9C7C
</style>